import Dots from './components/dots.js';
export const IconNew = {
  Dots
};